export const dashboardEs = {
  dashboard: {
    welcome: "Bienvenido a Sentinel Crop",
    parcels: "Parcelas",
    alerts: "Alertas",
    overview: "Resumen",
    totalParcels: "Total Parcelas",
    activeAlerts: "Alertas Activas",
    totalArea: "Superficie Total",
    lastUpdate: "Última Actualización",
    recentActivity: "Actividad Reciente",
    quickActions: "Acciones Rápidas",
    viewAll: "Ver Todo",
    noAlerts: "Sin alertas activas",
    parcelHealth: "Salud de Parcelas",
    weatherForecast: "Pronóstico del Tiempo",
    upcomingTasks: "Tareas Pendientes"
  },
  emptyState: {
    welcome: "Bienvenido a Sentinel Crop",
    subtitleParcels: "Comienza a monitorear tus parcelas con tecnología satelital e información impulsada por IA",
    subtitleGreenSpaces: "Comienza a monitorear tus espacios verdes con tecnología satelital e información impulsada por IA",
    realtimeAnalytics: "Análisis en Tiempo Real",
    realtimeAnalyticsDesc: "Índices NDVI, NDWI, EVI",
    riskMonitoring: "Monitoreo de Riesgos",
    riskMonitoringDesc: "Alertas de sequía, plagas y heladas",
    aiRecommendations: "Recomendaciones IA",
    aiRecommendationsDesc: "Riego y fertilización",
    addFirstParcel: "Añade Tu Primera Parcela",
    addFirstGreenSpace: "Añade Tu Primer Espacio Verde",
    quickStart: "Solo te tomará 2 minutos comenzar"
  },
  onboarding: {
    stepOf: "Paso {{number}} de 03",
    back: "Atrás",
    next: "Siguiente",
    skip: "Saltar Tour",
    step1Title: "Crea Tu Primera Parcela",
    step1Subtitle: "Dibuja tu campo en el mapa",
    step1Description: "Define los límites de tu terreno agrícola. Calcularemos automáticamente el área y comenzaremos a monitorearla con imágenes satelitales Sentinel-2.",
    step1Action: "Ir a Parcelas",
    step1Tip1: "Dibuja un polígono en el mapa o introduce coordenadas",
    step1Tip2: "Añade tipo de cultivo y variedad para un análisis preciso",
    step1Tip3: "El área se calcula automáticamente a partir del polígono",
    step2Title: "Ver Análisis Satelital",
    step2Subtitle: "Comprende la salud de tu vegetación",
    step2Description: "Accede a los índices de vegetación NDVI de los satélites Copernicus Sentinel-2. Descubre qué zonas de tu campo prosperan y cuáles necesitan atención, con actualizaciones cada 5 días.",
    step2Action: "Ver Datos Satelitales",
    step2Tip1: "Verde = vegetación sana, Rojo = estrés detectado",
    step2Tip2: "Compara periodos para detectar cambios",
    step2Tip3: "Selección automática de imágenes sin nubes",
    step3Title: "Recibe Tu Primera Recomendación",
    step3Subtitle: "Optimización de riego impulsada por IA",
    step3Description: "Recibe recomendaciones de riego personalizadas basadas en la metodología FAO-56, datos meteorológicos en tiempo real y tu tipo de suelo. Empieza a ahorrar agua desde el primer día.",
    step3Action: "Abrir Optimizador de Riego",
    step3Tip1: "Las recomendaciones se actualizan a diario con el clima",
    step3Tip2: "Basadas en la metodología FAO-56 Penman-Monteith",
    step3Tip3: "Sigue el balance hídrico de cada parcela automáticamente"
  },
  dashboardPage: {
    welcome: "Centro de Operaciones Agrícolas",
    welcomeUrban: "Bienvenido a Gestión Verde Urbana",
    subtitle: "Prioridades por parcela, decisiones bloqueadas, brechas de datos y acciones de campo de hoy.",
    subtitleUrban: "Tu resumen diario: salud de los espacios verdes, alertas activas y tareas de mantenimiento",
    allSystemsOp: "Resumen operativo listo",
    opsBriefReady: "Resumen operativo listo",
    opsBriefReadySub: "Construido con los datos actuales de las parcelas",
    opsBriefBadge: "Resumen de hoy",
    briefParcelsAttention: "Parcelas que requieren atención",
    briefActiveRisks: "Riesgos activos",
    briefFieldTasks: "Tareas de campo recientes",
    operationalPriorities: "Prioridades Operativas",
    prioritiesEmptyTitle: "Sin prioridades urgentes detectadas",
    prioritiesEmptyDesc: "Según los datos actuales. Los nuevos análisis satelitales o alertas aparecerán aquí automáticamente.",
    priorityHighRisk: "Riesgo satelital alto",
    priorityHighRiskReason: "El último análisis satelital marca esta parcela como riesgo alto. Revisa NDVI y alertas antes de actuar.",
    priorityCriticalRisk: "Riesgo satelital crítico",
    priorityCriticalRiskReason: "El último análisis satelital marca esta parcela como crítica. Inspecciona de inmediato.",
    priorityMissingAnalysis: "Sin datos satelitales aún",
    priorityMissingAnalysisReason: "No hay análisis satelital registrado para esta parcela. Genera análisis para habilitar decisiones.",
    priorityMissingPlanting: "Falta fecha de siembra",
    priorityMissingPlantingReason: "La fecha de siembra es necesaria para fenología, calendario de riego e informes.",
    priorityCtaReview: "Revisar parcela",
    priorityCtaOpen: "Abrir parcela",
    dataGapsTitle: "Brechas de Datos que Bloquean Decisiones",
    dataGapsEmpty: "No se detectaron brechas de datos bloqueantes con los datos actuales del panel.",
    gapNoAnalytics: "Parcelas sin análisis satelital",
    gapNoAnalyticsDetail: "Estas parcelas no tienen registro NDVI/riesgo aún. No se pueden generar decisiones.",
    gapNoPlanting: "Parcelas sin fecha de siembra",
    gapNoPlantingDetail: "Necesaria para fenología, calendario de riego e informes.",
    gapCta: "Gestionar parcelas",
    nextFieldActions: "Próximas Acciones de Campo",
    portfolioHealth: "Salud del Portafolio",
    topIssue: "Problema principal",
    addNewParcel: "Añadir Nueva Parcela",
    addNewGreenSpace: "Añadir Nuevo Espacio Verde",
    addFirstParcel: "Añade Tu Primera Parcela",
    addFirstGreenSpace: "Añade Tu Primer Espacio Verde",
    activeParcels: "Parcelas Activas",
    activeGreenSpaces: "Espacios Verdes Activos",
    noParcelYet: "Aún no hay parcelas registradas. Añade tu primera parcela para empezar a monitorear tus cultivos",
    noGreenSpaceYet: "Aún no hay espacios verdes registrados. Comienza añadiendo tu primer espacio verde.",
    totalCoverage: "Cobertura Total",
    activePolicies: "pólizas activas",
    noPoliciesYet: "Sin pólizas aún",
    avgNdvi: "NDVI Promedio",
    satelliteAnalysis: "Análisis satelital",
    noDataAvailable: "Sin datos disponibles",
    riskLevel: "Nivel de Riesgo",
    basedOnSatellite: "Basado en datos satelitales",
    noAssessmentYet: "Sin evaluación aún",
    frostProtection: "Protección contra Heladas",
    frostDesc: "Predicción de heladas 48-72h con modelado microclimático y alertas SMS",
    premiumModule: "Módulo Premium",
    viewDashboard: "Ver Panel →",
    fao56Irrigation: "Riego FAO-56",
    fao56Desc: "Riego científico con método de Doble Coeficiente (Kcb + Ke)",
    multiStationAemet: "Multi-Estación AEMET",
    optimizeNow: "Optimizar Ahora →",
    pkFertilization: "Fertilización P&K",
    pkDesc: "Integración de datos de suelo europeos con fertilización de precisión",
    premium25m: "Datos Premium 25m",
    planNutrients: "Planificar Nutrientes →",
    recentAlerts: "Alertas Recientes",
    noAlertsYet: "Sin Alertas Aún",
    noAlertsDesc: "Una vez que añadas parcelas, recibirás alertas sobre condiciones de cultivo y eventos climáticos.",
    fieldNotebook: "Cuaderno de Campo",
    viewAll: "Ver Todo",
    noActivitiesYet: "Sin Actividades Aún",
    noActivitiesDesc: "Comienza a registrar tus actividades agrícolas para seguir tu trabajo y obtener validación por IA.",
    cropResources: "Recursos de Cultivo y Base de Conocimiento",
    exploreResources: "Explorar Recursos",
    cropResourcesDesc: "Accede a guías completas sobre variedades de cultivo, temporadas de siembra, etapas de crecimiento y parámetros agronómicos",
    cropProgress: "Seguimiento del Progreso del Cultivo",
    addPlantingDates: "Añade fechas de siembra a tus parcelas para seguir el progreso del cultivo",
    monitorGrowth: "Monitorea etapas de crecimiento, necesidades de agua y predicciones de cosecha",
    configureParcels: "Configurar Parcelas",
    marketIntelligence: "Inteligencia de Mercado",
    marketDesc: "Precios de materias primas en tiempo real y tendencias del mercado",
    quickActions: "Acciones Rápidas",
    viewSatellite: "Ver Satélite",
    ndviAnalysis: "Análisis NDVI",
    irrigationLabel: "Riego",
    fao56Dual: "FAO-56 Dual",
    pkOptimizer: "Optimizador P&K",
    fertilizerZones: "Zonas de Fertilización",
    frostProtectionShort: "Protección Heladas",
    alerts48h: "Alertas 48-72h",
    ocrFoliar: "OCR Foliar",
    labReports: "Informes Lab",
    phenology: "Fenología",
    growthStages: "Etapas de Crecimiento",
    analyticsLabel: "Análisis",
    viewInsights: "Ver Insights",
    viewFullAnalytics: "Ver Análisis Completo",
    loadingDashboard: "Cargando tu panel...",
    accountSetupIncomplete: "Configuración de Cuenta Incompleta",
    accountSetupDesc: "Tu cuenta no está completamente configurada. Contacta soporte para completar tu configuración.",
    backToLogin: "Volver al Inicio de Sesión",
    sessionExpired: "Sesión Expirada",
    sessionExpiredDesc: "Tu sesión ha expirado. Inicia sesión de nuevo para continuar.",
    goToLogin: "Ir al Inicio de Sesión",
    hectaresTotal: "hectáreas en total",
    notifications: "Notificaciones",
    notificationsHint: "Elementos derivados de los datos actuales del panel",
    notificationsEmpty: "No hay notificaciones pendientes según los datos actuales.",
    notifType_alert: "Alerta",
    notifType_gap: "Dato faltante",
    notifType_task: "Tarea",
    notifType_reminder: "Recordatorio",
    tasksReminders: "Tareas y Recordatorios",
    tasksRemindersEmpty: "No hay recordatorios pendientes según los datos actuales.",
    reminderConfirmPlanting: "Confirmar fecha de siembra",
    reminderConfirmPlantingDetail: "Necesaria para fenología, riego e informes.",
    reminderGenerateAnalysis: "Generar análisis satelital",
    reminderGenerateAnalysisDetail: "Sin NDVI/riesgo no se pueden generar decisiones.",
    reminderReviewRisk: "Revisar señal de riesgo crítico",
    reminderReviewRiskDetail: "Abre la parcela con mayor riesgo detectado.",
    reminderOpenIrrigation: "Abrir Optimizador de Riego",
    reminderOpenIrrigationDetail: "Planifica agua para parcelas con estrés activo.",
    reminderOpenFarmOps: "Abrir Gaucho",
    reminderOpenFarmOpsDetail: "Revisa decisiones pendientes por parcela en un solo lugar.",
    reminderSelectForAdvisor: "Selecciona parcela para el Advisor",
    reminderSelectForAdvisorDetail: "Abre una parcela para lanzar el Advisor de IA desde su vista de detalle.",
    ctaOpen: "Abrir",
    ctaReview: "Revisar",
    olderSignal: "Señal antigua",
    alertsShownOfTotal: "Mostrando {{shown}} de {{total}}",
    riskSignals: "Señales de Riesgo",
    activeSignals: "señales activas",
    olderSignalsAvailable: "Señales antiguas disponibles en Alertas",
    openAlerts: "Abrir alertas"
  },
  workflowBanner: {
    title: "Empieza por Monitorizar",
    subtitle: "Revisa señales de parcela, alertas y datos faltantes, y avanza hacia flujos de riego, fertilización, riesgo o reportes.",
    stepLabels: "Monitorizar → Decidir → Reportar → Demostrar"
  },
  reportsCenterBanner: {
    title: "Reportar y Demostrar",
    subtitle: "Genera informes por parcela con disponibilidad de datos, recomendaciones, limitaciones y trazabilidad documental con SHA-256.",
    quickLinks: {
      digitalParcelRecord: "Registro Digital de Parcela",
      pacReadiness: "Verificación PAC",
      irrigationReports: "Informes de Riego"
    }
  },
  reportsPurpose: {
    title: "¿Para qué sirven estos informes?",
    subtitle: "Los informes están diseñados para apoyar decisiones, revisiones y documentación interna — no sustituyen certificaciones oficiales, valoraciones legales ni peritajes de seguros.",
    cards: {
      explainDecisions: "Explicar decisiones agronómicas",
      documentEvent: "Documentar condiciones tras un siniestro asegurado",
      internalEvidence: "Preparar evidencia interna",
      supportWorkflows: "Apoyar flujos de cooperativas o asesores"
    }
  },
  sentinelScore: {
    calculating: "Calculando SentinelScore™...",
    subtitle: "Salud global de tus parcelas basada en datos satelitales, riesgos meteorológicos y alertas activas",
    excellent: "Excelente",
    good: "Bueno",
    attention: "Necesita Atención",
    critical: "Crítico",
    tooltip: "Índice de salud compuesto: Tendencia NDVI (30%) + Estrés Hídrico (25%) + Riesgo de Helada (20%) + Presión de Plagas (15%) + Desviación GDD (10%)",
    byParcel: "Puntuación por Parcela",
    moreParcels: "parcelas más",
    noParcels: "Añade parcelas para ver tu índice de salud compuesto.",
    parcelsTracked: "parcelas monitorizadas",
    needAttention: "requieren atención",
    viewPortfolio: "Ver salud del portafolio"
  }
};
